<!--
 * @Description: 
 * @Author: pcc
 * @Date: 2023-08-07 09:09:08
 * @LastEditors: xie
 * @LastEditTime: 2025-12-12 17:29:43
-->
<template>
  <div class="print">
    <div class="title">样品进出登记</div>
    <div class="search">
      <el-form ref="formData" :inline="true" :model="formData">
        <div class="row">
          <el-form-item label="公司编号:" prop="co_Nu">
            <el-input
              style="width: 4rem;"
              ref="input"
              v-model="formData.co_Nu"
              placeholder="公司编号"
              @keydown.enter.native="broadcast($event)"
              @blur="onblur"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="button" style="width:100px; background: #1890ff;color:#fff" :loading="loading" @click="broadcast($event)">确定</el-button>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item>
            <el-radio-group v-model="formData.category" @change="onChange">
              <el-radio :label="1">进展</el-radio>
              <el-radio :label="2">厂家带走</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import { createProductOut } from '@/api/home'
import { mapState } from 'vuex'
var socketTimer = null
export default {
  data() {
    return {
      loading: false,
      isFocus: false,
      // 查询参数
      formData: {
        co_Nu: '',
        category: 1
      },
      path: 'ws://127.0.0.1:11999',
      socket: '',
      repeatCount: 1,
      searchType: '公司编号查询',
      msg: '',

    }
  },
  computed: {
    ...mapState('tenant', ['tenantInfo'])
  },
  mounted() {
    this.initData()
    this.initSocket()
    this.$refs.input.focus()
  },
  destroyed() {
    this.socket = ''
    if (socketTimer) {
      clearInterval(socketTimer)
    }
  },
  methods: {
    initData() {
      this.formData.category = JSON.parse(localStorage.getItem('category')) || 1
    },
    onChange() {
      localStorage.setItem('category', JSON.stringify(this.formData.category))
    },
    // 初始化Socket
    initSocket() {
      if (typeof (WebSocket) === 'undefined') {
        this.$message.warning('您的浏览器不支持socket，将无法使用语音播报功能')
      } else {
        this.socket = new WebSocket(this.path)
        // 连接socket
        this.socket.onopen = () => { }

        // 连接错误
        this.socket.onerror = () => {
          const _this = this
          // 清楚socket心跳检测
          if (socketTimer) {
            clearInterval(socketTimer)
          }

          setTimeout(() => {
            _this.initSocket()
          }, 5000)
        }

        // 监听消息
        this.socket.onmessage = (res) => {
          if (res.data === 'ok') {
            if (this.repeatCount > 0) {
              this.speakText()
            }
          }
        }
      }
    },
    // socket心跳检测
    heartCheck() {
      if (socketTimer) {
        clearInterval(socketTimer)
      }

      const _this = this
      socketTimer = setInterval(() => {
        if (_this.socket.readyState !== 1) {
          _this.initSocket()
        }
      }, 3000)
    },
    // 聚焦
    onblur() {
      if (!this.isFocus) {
        this.isFocus = true
        setTimeout(() => {
          this.isFocus = false
          this.searchType = '公司编号查询'
          this.$refs.input.focus()
        }, 10000)
      }
    },
    // 发送语音播报
    speakText() {
      this.repeatCount--
      const speakMessage = this.msg
        .replaceAll('0', ' 0 ')
        .replaceAll('1', ' 1 ')
        .replaceAll('2', ' 2 ')
        .replaceAll('3', ' 3 ')
        .replaceAll('4', ' 4 ')
        .replaceAll('5', ' 5 ')
        .replaceAll('6', ' 6 ')
        .replaceAll('7', ' 7 ')
        .replaceAll('8', ' 8 ')
        .replaceAll('9', ' 9 ')
        .replaceAll('-', ' 杠 ')
        .replaceAll('_', ' 杠 ')

      const objData = {
        type: 2,
        message: speakMessage
      }
      this.socket.send(JSON.stringify(objData))
    },
    // 播报
    async broadcast(e) {
      e.preventDefault();
      this.repeatCount = 1
      // 校验厂商编号是否输入
      if (!this.formData.co_Nu) {
        this.$message.warning('请输入公司编号')
        this.$refs.input.focus()
        return
      }
      createProductOut(this.formData).then(res => {
        if (res.success) {
          this.msg = this.formData.category == 1 ? '样品进展' : '样品带出'
          this.$message.success(this.msg)
          this.formData.co_Nu = ''
          this.speakText()
          this.$refs.input.focus()
        } else {
          this.$message.warning(res.message)
          this.msg = res.message
          this.formData.co_Nu = ''
          this.speakText()
          this.$refs.input.focus()
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.print {
  height: 100vh;
  font-family: MicrosoftYaHei;
  .title {
    text-align: center;
    padding: 0.2rem;
    font-size: 0.3rem;
    font-weight: bold;
    border: 0.01rem solid #eee;
  }

  .search {
    display: flex;
    align-items: center;
    min-height: 1.1rem;
    // height: 10%;
    padding: 0 0.3rem;

    .row {
      padding-top: 20px;
      margin-bottom: 30px;
      width: 100%;
      display: flex;
      align-items: center;
    }
    :deep .el-form-item {
      display: flex;
      align-items: center;
      margin: 0 0.2rem 0 0;

      .el-form-item {
        display: flex;
        align-items: center;
      }

      .el-form-item__label {
        font-size: 0.18rem !important;
        color: #222222;
      }

      .el-input__inner {
        font-size: 0.18rem !important;
        height: 0.4rem !important;
        line-height: 0.4rem !important;
        color: #8a8a8a;
      }
      // button {
      //   height: 0.4rem !important;
      //   line-height: 0.4rem;
      //   padding: 0 0.06rem;
      //   font-size: 0.18rem !important;
      //   width: 1rem;
      //   color: #848484;
      //   width: 2rem;
      // }
    }
  }
}
</style>